export { useSwiperController } from './useSwiperController';
export type { UseSwiperControllerOptions, SwiperInstanceLike } from './types';
